import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {IonicModule} from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CustomLoadingComponent } from './custom-loading';

@NgModule({
  declarations: [
    CustomLoadingComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
  ],
  exports: [
    CustomLoadingComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class CustomLoadingComponentModule {}
